/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { AvForm } from 'availity-reactstrap-validation';
import { NavItem, NavLink, Row } from 'reactstrap';

import './BrandCustom.scss';

const TestIForm = ({ selectedRow, milestoneConfig, columsPop = 4, colors }: any) => {

    const [listVisibleInModalHeader, setlistVisibleInModalHeader] = useState([{}]);
    const [listIsMilestones, setlistIsMilestones] = useState([{}]);
    const [listVisibleInModalBody, setlistVisibleInModalBody] = useState([{}]);
    const [listVisibleInModalTotal, setlistVisibleInModalTotal] = useState([{}]);
    const [state, setState] = useState<any>({});

    useEffect(() => {
        const modalHeader = milestoneConfig.filter((x: { visibleInModalHeader: boolean }) => x.visibleInModalHeader === true);
        const isMilestone = milestoneConfig.filter((x: { isMilestone: boolean }) => x.isMilestone === true);
        const modalBody = milestoneConfig.filter((x: { visibleInModalBody: boolean }) => x.visibleInModalBody === true);
        const modalTotal = milestoneConfig.filter((x: { visibleInModalTotal: boolean }) => x.visibleInModalTotal === true);

        setlistVisibleInModalHeader(processList(modalHeader, selectedRow));
        setlistIsMilestones(processList(isMilestone, selectedRow));
        setlistVisibleInModalBody(processList(modalBody, selectedRow));
        setlistVisibleInModalTotal(processList(modalTotal, selectedRow));
    }, [selectedRow, milestoneConfig]);

    useEffect(() => {
        setState(colors)
    }, [colors]);

    const processList = (list: any[], selectedRow: any) => {
        const t: any[] = [];
        for (const item in selectedRow) {
            list.map(function (data: { dataField: string }, index: any) {
                if (data.dataField === item)
                    t.push({
                        ...data,
                        value: selectedRow[item],
                    });
                return data;
            });
        }

        return t;
    };


    const renderModalHeader = () => {
        return (
            <React.Fragment >
                {
                    listVisibleInModalHeader.length
                        ? listVisibleInModalHeader.map((item: any, key: any) => {
                            const { text, value } = item;
                            if (value != '' && value != null) {
                                return (
                                    <div key={key} >
                                        <label style={{ color: colors?.modalHeaderTitle }} className="labelModal"> {text}</label>
                                        <label style={{ color: colors?.modalHeaderText }} className="labelInfoModal"> {value}</label>
                                    </div>
                                );
                            }
                        }) : null
                }
            </React.Fragment>
        );
    };



    const renderInModalBody = () => {
        return (
            <React.Fragment>
                {
                    listVisibleInModalBody.length
                        ? listVisibleInModalBody.map((item: any, key: any) => {
                            const { text, value } = item;
                            if (value != '' && value != null) {
                                return (
                                    <div key={key}>
                                        <label style={{ color: colors?.modalBodyTitle }} className="labelModal"> {text} </label>
                                        <label style={{ color: colors?.modalBodyText }} className="labelInfoModal"> {value}</label>
                                    </div>
                                );
                            }
                        }) : null
                }
            </React.Fragment>
        );
    };

    const renderInModalTotal = () => {
        return (
            <React.Fragment>
                <div>
                    {
                        listVisibleInModalTotal.length
                            ? listVisibleInModalTotal.map((item: any, key: any) => {
                                const { text, value } = item;
                                if (value != '' && value != null) {
                                    return (
                                        <label style={{ color: colors?.modalTotalText }} className="labelTotalPieces" key={key}>
                                            {' '}
                                            {text} : {value}{' '}
                                        </label>
                                    );
                                }
                            }) : null
                    }
                </div>
            </React.Fragment>
        );
    };
    return (
        <div className="formContainer" >
            <Row className="upRown" style={{ backgroundColor: state?.modalHeaderBackground }}>
                <AvForm
                    className="custom-form mt-0"
                    style={{
                        display: 'grid',
                        gridTemplateColumns: `repeat(${columsPop}, 1fr)`,
                        gridAutoRows: 'minmax(10%, 60px)',
                        gridGap: '2%',
                        padding: '0',
                        textAlign: 'center',
                    }}
                >
                    {listVisibleInModalHeader.length ? renderModalHeader() : null}
                </AvForm>
            </Row>
            <Row className="MiddleRown" style={{ backgroundColor: state?.isMilestoneBackground }}>
                <div id="basic-pills-wizard" className="twitter-bs-wizard">
                    <ul className="twitter-bs-wizard-nav nav nav-pills nav-justified" >
                        {listIsMilestones.length
                            ? listIsMilestones.map((item: any, key: any) => {
                                const { text } = item;
                                return (
                                    <NavItem key={key}>
                                        <NavLink
                                            to="#"
                                        >
                                            <div
                                                style={{ backgroundColor: state?.isMilestoneCircle, color: state?.isMilestoneBackground }}
                                                className="step-icon iconStep1Test"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title={text}
                                            >
                                                <i className="bx bx-check"></i>
                                            </div>
                                        </NavLink>
                                    </NavItem>
                                );
                            })
                            : null}
                    </ul>

                    <ul className="twitter-bs-wizard-nav nav nav-pills nav-justified">
                        {listIsMilestones.length
                            ? listIsMilestones.map((item: any, key: any) => {
                                const { value } = item;
                                return (
                                    <NavItem key={key} >
                                        <label style={{ color: state?.isMilestoneText }}>{value} </label>
                                    </NavItem>
                                );
                            })
                            : null}
                    </ul>
                    {/* <BasicPills data={listIsMilestones} /> */}
                </div>
            </Row>

            <Row className="DownRown" style={{ backgroundColor: state?.modalBodyBackground }}>
                <AvForm
                    className="custom-form mt-0"
                    style={{
                        display: 'grid',
                        gridTemplateColumns: `repeat(${columsPop}, 1fr)`,
                        gridAutoRows: 'minmax(10%, 80px)',
                        gridGap: '2%',
                        padding: '0',
                    }}
                >
                    {listVisibleInModalBody.length ? renderInModalBody() : null}
                </AvForm>
            </Row>
            <Row
                style={{
                    padding: '0',
                    textAlign: 'center',
                    maxHeight: 100,
                    overflow: 'auto',
                    backgroundColor: state?.modalTotalBackground
                }}
                className="rowTotalPiecesTest"
            >
                {listVisibleInModalTotal.length ? renderInModalTotal() : null}
            </Row>
        </div>
    );
};

TestIForm.propTypes = {
    selectedRow: PropTypes.shape({
        Number: PropTypes.string,
        SellerName: PropTypes.string,
    }),
    milestoneConfig: PropTypes.shape({
        Number: PropTypes.string,
        SellerName: PropTypes.string,
        OperationName: PropTypes.string,
        OperationType: PropTypes.string,
        dataField: PropTypes.string,
        isMilestone: PropTypes.bool,
        order: PropTypes.string,
        text: PropTypes.string,
        userId: PropTypes.string,
        visibleInMiddle: PropTypes.bool,
        visibleInModalFooter: PropTypes.bool,
        visibleInModalHeader: PropTypes.bool,
        visibleInTable: PropTypes.bool,
        hidden: PropTypes.bool,
        visibleInModalBody: PropTypes.bool,
        visibleInModalTotal: PropTypes.bool,
    }),
    colors: PropTypes.any,
    columsPop: PropTypes.number
};

export default TestIForm;
